// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

export const loadTrackingInfo = (state: ApplicationState) => {
    return state.store.pages.orderDetails;
};

export const canRmaOrder = (state: ApplicationState, order?: OrderModel) => {
    const orderStatusMappings = getOrderStatusMappingDataView(state).value;
    if (!orderStatusMappings) {
        return false;
    }
    return (
        order !== undefined &&
        orderStatusMappings.some(status => status.erpOrderStatus === order.status && status.allowRma) &&
        order?.orderLines?.some(line => line.properties["isReturnable"] && line.properties["isReturnable"] === "true") // Store Custom Code
    );
};
